// extracted by mini-css-extract-plugin
module.exports = {"container":"day_container__GkuHP","content":"day_content__26iXq","arrow":"day_arrow__3RiZt","back_btn":"day_back_btn__3w4Am"};